import { render } from "./PasswordReset.vue?vue&type=template&id=5caae634"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__